import { UnderConstructionComponent } from './components/views/under-construction/under-construction.component';
import { HomeComponent } from './components/views/home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from './components/views/privacy-policy/privacy-policy.component';
import { NotFoundComponent } from './components/views/not-found/not-found.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'privacy/:type/:app', component: PrivacyPolicyComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
